import React, { useEffect, useRef, useState } from "react";
import { RefreshCw } from "lucide-react";
import { toast } from "sonner";
import * as api from "../../lib/api";
import { Button } from "../ui/button";

const summary = (s) => {
    const parts = [`${s.created} créés`, `${s.updated} mis à jour`];
    if (s.departed) parts.push(`${s.departed} départs`);
    if (s.reactivated) parts.push(`${s.reactivated} réactivés`);
    if (s.errors) parts.push(`${s.errors} erreurs`);
    return parts.join(", ");
};

// Bouton « Forcer la synchro MS365 » : lance la synchro en arrière-plan puis suit la progression
export function EntraSyncButton({ onDone, size = "sm", variant = "outline", className = "", label = "Synchroniser MS365", onStatus }) {
    const [status, setStatus] = useState(null);
    const [starting, setStarting] = useState(false);
    const pollRef = useRef(null);
    const wasRunning = useRef(false);

    const refresh = async () => {
        try {
            const s = await api.getEntraSyncStatus();
            setStatus(s);
            onStatus?.(s);
            if (wasRunning.current && !s.running) {
                wasRunning.current = false;
                if (s.last_error) toast.error(`Synchronisation échouée : ${s.last_error}`);
                else if (s.last_sync) toast.success(`Synchronisation terminée : ${summary(s.last_sync)}`);
                onDone?.(s);
            }
            if (s.running) wasRunning.current = true;
            return s;
        } catch { return null; }
    };

    useEffect(() => {
        refresh();
        pollRef.current = setInterval(() => { if (wasRunning.current) refresh(); }, 2500);
        return () => clearInterval(pollRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const start = async () => {
        setStarting(true);
        try {
            await api.triggerEntraSync();
            wasRunning.current = true;
            toast.info("Synchronisation Microsoft 365 lancée…");
            setTimeout(refresh, 800);
        } catch (e) {
            toast.error(e.response?.data?.detail || "Impossible de lancer la synchronisation");
        } finally { setStarting(false); }
    };

    const running = !!status?.running;
    const progress = status?.progress;
    const disabled = starting || running || status?.enabled === false;
    return (
        <Button size={size} variant={variant} onClick={start} disabled={disabled} className={className}
            title={status?.enabled === false ? "Entra ID non configuré" : "Forcer une synchronisation des utilisateurs Microsoft 365"} data-testid="entra-sync-btn">
            <RefreshCw className={`w-3.5 h-3.5 mr-1.5 ${running || starting ? "animate-spin" : ""}`} />
            {running ? `Synchronisation… ${progress?.seen ? `(${progress.seen})` : ""}` : label}
        </Button>
    );
}
